/**
 * Data mappers for converting GraphQL Dispute types to legacy IDispute interface
 */

import type { IDispute } from '../../../../ts/interface/transaction.interface';
import type { DisputeGraphQL } from './useDisputesRelay';
import { convertCentsToMoney, toTitleCase } from '../../../../utils';

/**
 * Map GraphQL Dispute to legacy IDispute interface
 */
export function mapDisputeToIDispute(dispute: DisputeGraphQL): IDispute {
  const userName = dispute.user
    ? `${dispute.user.firstName ?? ''} ${dispute.user.lastName ?? ''}`.trim()
    : '';

  return {
    id: dispute.id,
    gid: dispute.id,
    charge_id: dispute.chargeId,
    amount: convertCentsToMoney(dispute.amount),
    fee: convertCentsToMoney(dispute.fee ?? 0),
    net: convertCentsToMoney(dispute.net ?? 0),
    status: toTitleCase(dispute.status.replace(/_/g, ' ')),
    reason: dispute.reason
      ? toTitleCase(dispute.reason.replace(/_/g, ' '))
      : '',
    created: dispute.createdOn,
    evidence_duedate: dispute.evidenceDueBy ?? '',
    system: dispute.system?.oldId ?? dispute.systemId ?? '',
    userName,
    email: dispute.user?.email ?? '',
    phone: dispute.user?.phone?.toString() ?? '',
    userPhone: dispute.user?.phone?.toString() ?? '',
  };
}

/**
 * Map array of GraphQL disputes to IDispute array
 */
export function mapDisputesToIDisputes(
  disputes: DisputeGraphQL[]
): IDispute[] {
  return disputes.map(mapDisputeToIDispute);
}
